import './App.css';
import { HelmetProvider } from 'react-helmet-async';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="app">
          <Navbar />
          <Routes>
            <Route path="/"         element={<Home />}     />
            <Route path="/about"    element={<About />}    />
            <Route path="/contact"  element={<Contact />}  />
            <Route path="/services" element={<Services />} />
            <Route path="/privacy"  element={<Privacy />}  />
            <Route path="/terms"    element={<Terms />}    />
          </Routes>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;